import { render } from "./WordUnscramble.vue?vue&type=template&id=4531bed1&scoped=true"
import script from "./WordUnscramble.vue?vue&type=script&lang=js"
export * from "./WordUnscramble.vue?vue&type=script&lang=js"

import "./WordUnscramble.vue?vue&type=style&index=0&id=4531bed1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4531bed1"]])

export default __exports__